// Persona → landing route. Must match backend `personas.py`.
export const PERSONA_HOME = {
  'student-build': '/app',
  'student-seed':  '/app',
  'mentor':        '/app/mentor-home',
  'parent':        '/app/parent',
  'admin':         '/app/admin',
  'investor':      '/app/investor-home',
  'alumni':        '/app/alumni-home',
  'partner':       '/app/partner-home',
  'user':          '/app/user-home',
};

// Where to send a user after login. Admins (persona, super-admin flag, or any
// admin role) always land on the Admin dashboard.
export const homeForUser = (u) => {
  if (!u) return '/app';
  if (u.persona === 'admin' || u.is_super_admin || u.admin_role) return '/app/admin';
  return PERSONA_HOME[u.persona] || '/app';
};
